var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_598_1519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4189 11.9771C23.721 11.2253 24.1671 9.56027 23.4154 8.25815C22.6636 6.95604 20.9986 6.5099 19.6965 7.26167L10.4232 12.6156C9.82865 12.823 9.30286 13.2365 8.96333 13.8246C8.70857 14.2658 8.59137 14.7488 8.59845 15.2237C8.59509 15.6919 8.71256 16.1671 8.96357 16.6019C9.30287 17.1896 9.82819 17.6029 10.4222 17.8104L19.6962 23.1648C20.9983 23.9166 22.6634 23.4704 23.4151 22.1683C24.1669 20.8662 23.7208 19.2012 22.4187 18.4494L16.8135 15.2133L22.4189 11.9771Z",
    fill: "#2EADD4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_598_1519)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_598_1519",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08409 0.365191C6.78198 -0.386586 5.11697 0.0595507 4.36519 1.36167C3.61341 2.66378 4.05955 4.32879 5.36167 5.08057L10.9663 8.31639L5.36245 11.5518C4.06033 12.3035 3.61419 13.9686 4.36597 15.2707C5.11775 16.5728 6.78276 17.0189 8.08487 16.2671L17.3547 10.9152C17.9502 10.7081 18.477 10.2943 18.817 9.70541C19.0638 9.27796 19.1815 8.8114 19.1822 8.35088C19.1938 7.86796 19.077 7.37587 18.8178 6.92692C18.477 6.33674 17.9487 5.9224 17.3515 5.71575L8.08409 0.365191Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08409 0.365191C6.78198 -0.386586 5.11697 0.0595507 4.36519 1.36167C3.61341 2.66378 4.05955 4.32879 5.36167 5.08057L10.9663 8.31639L5.36245 11.5518C4.06033 12.3035 3.61419 13.9686 4.36597 15.2707C5.11775 16.5728 6.78276 17.0189 8.08487 16.2671L17.3547 10.9152C17.9502 10.7081 18.477 10.2943 18.817 9.70541C19.0638 9.27796 19.1815 8.8114 19.1822 8.35088C19.1938 7.86796 19.077 7.37587 18.8178 6.92692C18.477 6.33674 17.9487 5.9224 17.3515 5.71575L8.08409 0.365191Z",
    fill: "url(#paint0_linear_598_1519)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36519 1.36167L4.7982 1.61167L4.36519 1.36167ZM8.08409 0.365191L7.83409 0.798203V0.798203L8.08409 0.365191ZM5.36167 5.08057L5.11167 5.51358L5.36167 5.08057ZM10.9663 8.31639L11.2163 8.7494L11.9663 8.31639L11.2163 7.88338L10.9663 8.31639ZM5.36245 11.5518L5.61245 11.9848L5.36245 11.5518ZM4.36597 15.2707L4.79898 15.0207L4.36597 15.2707ZM8.08487 16.2671L7.83487 15.8341H7.83487L8.08487 16.2671ZM17.3547 10.9152L17.1904 10.443L17.1457 10.4585L17.1047 10.4822L17.3547 10.9152ZM18.817 9.70541L18.384 9.45541L18.384 9.45541L18.817 9.70541ZM19.1822 8.35088L18.6822 8.33888L18.6822 8.35012L19.1822 8.35088ZM18.8178 6.92692L19.2508 6.67692V6.67692L18.8178 6.92692ZM17.3515 5.71575L17.1015 6.14877L17.1429 6.17264L17.188 6.18826L17.3515 5.71575ZM4.7982 1.61167C5.41191 0.548697 6.77112 0.184497 7.83409 0.798203L8.33409 -0.0678222C6.79283 -0.95767 4.82203 -0.429596 3.93218 1.11167L4.7982 1.61167ZM5.61167 4.64755C4.5487 4.03385 4.1845 2.67464 4.7982 1.61167L3.93218 1.11167C3.04233 2.65293 3.57041 4.62373 5.11167 5.51358L5.61167 4.64755ZM11.2163 7.88338L5.61167 4.64755L5.11167 5.51358L10.7163 8.7494L11.2163 7.88338ZM5.61245 11.9848L11.2163 8.7494L10.7163 7.88338L5.11245 11.1188L5.61245 11.9848ZM4.79898 15.0207C4.18528 13.9577 4.54948 12.5985 5.61245 11.9848L5.11245 11.1188C3.57119 12.0086 3.04311 13.9794 3.93296 15.5207L4.79898 15.0207ZM7.83487 15.8341C6.7719 16.4478 5.41269 16.0836 4.79898 15.0207L3.93296 15.5207C4.82281 17.0619 6.79361 17.59 8.33487 16.7002L7.83487 15.8341ZM17.1047 10.4822L7.83487 15.8341L8.33487 16.7002L17.6047 11.3482L17.1047 10.4822ZM18.384 9.45541C18.1062 9.93648 17.6769 10.2738 17.1904 10.443L17.5189 11.3875C18.2235 11.1425 18.8477 10.6521 19.25 9.95541L18.384 9.45541ZM18.6822 8.35012C18.6816 8.72547 18.5859 9.10575 18.384 9.45541L19.25 9.95542C19.5417 9.45018 19.6813 8.89734 19.6822 8.35164L18.6822 8.35012ZM18.3848 7.17692C18.5967 7.5441 18.6918 7.94516 18.6823 8.33888L19.682 8.36288C19.6958 7.79075 19.5572 7.20764 19.2508 6.67692L18.3848 7.17692ZM17.188 6.18826C17.6758 6.35707 18.1064 6.69481 18.3848 7.17692L19.2508 6.67692C18.8476 5.97867 18.2215 5.48774 17.5151 5.24325L17.188 6.18826ZM7.83409 0.798203L17.1015 6.14877L17.6015 5.28274L8.33409 -0.0678222L7.83409 0.798203Z",
    fill: "url(#paint1_linear_598_1519)",
    mask: "url(#path-2-inside-1_598_1519)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_598_1519",
    x: 4.59814,
    y: 6.89648,
    width: 23.1826,
    height: 24.6335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_598_1519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_598_1519",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_598_1519",
    x: 0,
    y: -4,
    width: 23.1831,
    height: 28.6323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_598_1519"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_598_1519",
    result: "effect2_dropShadow_598_1519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_598_1519",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_598_1519",
    x1: 14.7852,
    y1: 4.02808,
    x2: 8.78516,
    y2: 15.5281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_598_1519",
    x1: 9.5,
    y1: 8,
    x2: 19,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C5D75",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3DFE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExchange);
export default __webpack_public_path__ + "static/media/ico_exchange.700bb8606ffb551ce3e70ea482dc62f4.svg";
export { ForwardRef as ReactComponent };